import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { UsersServives } from 'v2/resources/services/users';
import {
  IGetUsersResponse,
  IPayloadPostNewuser,
} from 'v2/resources/types/users';
import { setUsers } from 'v2/store/dataChat/slice';
import { useAppDispatch } from '../../useAppSelector';
import { setToast } from 'v2/store/toast/slice';
import { IPayloadEditUser } from 'v2/resources/types/users';
import { useEffect } from 'react';

export const useQueryUsers = (
  refresh: boolean,
  nameProperty: any // TODO: Define proper type for nameProperty in refactor
): UseQueryResult<IGetUsersResponse[]> => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (refresh) {
      queryClient.refetchQueries(['getUsers', nameProperty]);
    }
  }, [refresh, nameProperty]);

  return useQuery({
    queryKey: ['getUsers', nameProperty],
    queryFn: () => UsersServives.getUsers(),
    enabled: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    onSuccess: (data) => {
      dispatch(setUsers(data));
    },
  });
};

export function usePostNewUser(fnSuccess: VoidFunction, fnError: VoidFunction) {
  const dispatch = useAppDispatch();
  return useMutation(
    async (payload: IPayloadPostNewuser) => UsersServives.postNewUser(payload),
    {
      onSuccess: () => {
        fnSuccess();
        dispatch(
          setToast({
            message: 'Usuário criado com sucesso!',
            severity: 'success',
          })
        );
      },
      onError: (err) => {
        dispatch(
          setToast({
            message: 'Erro ao criar usuário. :(',
            severity: 'error',
          })
        );
        fnError();
      },
    }
  );
}

export function useEditUser(fnSuccess: VoidFunction, fnError: VoidFunction) {
  const dispatch = useAppDispatch();
  return useMutation(
    async ({ payload, id }: { payload: IPayloadEditUser; id: number }) =>
      UsersServives.editUser(payload, id),
    {
      onSuccess: () => {
        fnSuccess();
        dispatch(
          setToast({
            message: 'Usuário editado com sucesso!',
            severity: 'success',
          })
        );
      },
      onError: (err) => {
        dispatch(
          setToast({
            message: 'Erro ao editar usuário. :(',
            severity: 'error',
          })
        );
        fnError();
      },
    }
  );
}
